export default {
    SLACK_WEBHOOK: 'https://hooks.slack.com/services/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'
}
